export default {
    SLACK_WEBHOOK: 'https://hooks.slack.com/services/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'
}
